<template>
  <b-modal
    id="modal-test-meta-capi-event"
    v-model="showModal"
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    dialog-class="custom-modal-capi"
  >
    <div class="">
      <!-- Header -->
      <div class="flex items-center justify-between pb-1 mb-1.5 border-b border-gray-100">
        <div>
          <h4 class="text-base font-bold text-[#333333] mb-0.5">
            Test CAPI Event
          </h4>
          <p class="text-xs text-[#828282] mb-0">
            Kirim test event ke Meta API Conversion. Isi customer data untuk meningkatkan match quality.
          </p>
        </div>
        <button
          type="button"
          class="p-0 border-0 bg-transparent text-gray-400 hover:text-gray-600 cursor-pointer focus:outline-none"
          @click="onCancel"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <!-- Form Body -->
      <div class="space-y-1.5">
        <!-- 1. Grup Event -->
        <div class="border border-gray-200 rounded-xl p-1 bg-white">
          <div class="text-sm font-medium text-[#222222] mb-1">
            Event
          </div>
          <div class="space-y-3">
            <div>
              <label class="block text-xs font-medium text-[#333333] mb-1.5">
                Jenis Event
              </label>
              <v-select
                v-model="selectedEventType"
                :options="eventTypeOptions"
                label="label"
                :reduce="opt => opt.value"
                :clearable="false"
                class="w-full text-xs custom-v-select"
              />
            </div>
            <div>
              <label class="block text-xs font-medium text-[#333333] mb-1.5">
                Nama Event
              </label>
              <v-select
                v-model="selectedEventName"
                :options="eventNameOptions"
                label="label"
                :reduce="opt => opt.value"
                :clearable="false"
                class="w-full text-xs custom-v-select"
              />
              <p
                v-if="!activeEvents.length"
                class="text-[11px] text-[#828282] mt-1 mb-0"
              >
                Belum ada Meta Event aktif
              </p>
            </div>
          </div>
        </div>

        <!-- 2. Grup Data Pelanggan (Hashed Otomatis) -->
        <div class="border border-gray-200 rounded-lg p-1 bg-[#FAFAFA]">
          <div class="mb-1">
            <h5 class="text-xs font-semibold text-[#333333] mb-0.5">
              Data Pelanggan (Hashed Otomatis)
            </h5>
            <p class="text-[11px] text-[#828282] mb-0">
              Data akan di hash SHA-256 sebelum dikirim ke Meta. Semakin lengkap, semakin tinggi match quality
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-1">
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                Telepon (ph)
              </label>
              <b-form-input
                v-model="customerData.phone"
                type="text"
                placeholder="08123123123"
                class="text-xs custom-input-field"
              />
            </div>
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                External ID
              </label>
              <b-form-input
                v-model="customerData.external_id"
                type="text"
                placeholder="231231"
                class="text-xs custom-input-field"
              />
            </div>
            <template v-if="showCustomerName">
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  Nama Depan (fn)
                </label>
                <b-form-input
                  v-model="customerData.first_name"
                  type="text"
                  placeholder="Jack"
                  class="text-xs custom-input-field"
                />
              </div>
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  Nama Belakang (ln)
                </label>
                <b-form-input
                  v-model="customerData.last_name"
                  type="text"
                  placeholder="Smith"
                  class="text-xs custom-input-field"
                />
              </div>
            </template>
            <template v-if="showCustomerLocation">
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  Kota (ct)
                </label>
                <b-form-input
                  v-model="customerData.city"
                  type="text"
                  placeholder="Jakarta"
                  class="text-xs custom-input-field"
                />
              </div>
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  Provinsi (st)
                </label>
                <b-form-input
                  v-model="customerData.state"
                  type="text"
                  placeholder="Jakarta"
                  class="text-xs custom-input-field"
                />
              </div>
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  Kode Pos (zp)
                </label>
                <b-form-input
                  v-model="customerData.zip"
                  type="text"
                  placeholder="123123"
                  class="text-xs custom-input-field"
                />
              </div>
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  Kode Negara (country)
                </label>
                <b-form-input
                  v-model="customerData.country"
                  type="text"
                  placeholder="ID"
                  class="text-xs custom-input-field"
                />
              </div>
            </template>
          </div>
        </div>

        <!-- 2b. Grup Custom Data (khusus InitiateCheckout & Purchase) -->
        <div
          v-if="showCustomData"
          class="border border-gray-200 rounded-lg p-1 bg-[#FAFAFA]"
        >
          <div class="mb-1">
            <h5 class="text-xs font-semibold text-[#333333] mb-0">
              Detail Transaksi (custom_data)
            </h5>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-1">
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                Price
              </label>
              <b-form-input
                v-model="customData.price"
                type="number"
                placeholder="350000"
                class="text-xs custom-input-field"
              />
            </div>
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                Currency
              </label>
              <b-form-input
                v-model="customData.currency"
                type="text"
                placeholder="IDR"
                class="text-xs custom-input-field"
              />
            </div>
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                Product Name
              </label>
              <b-form-input
                v-model="customData.product_name"
                type="text"
                placeholder="T-Shirt Premium"
                class="text-xs custom-input-field"
              />
            </div>
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                Content Type
              </label>
              <b-form-input
                v-model="customData.content_type"
                type="text"
                placeholder="product"
                class="text-xs custom-input-field"
              />
            </div>
            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                Quantity
              </label>
              <b-form-input
                v-model="customData.quantity"
                type="number"
                placeholder="1"
                class="text-xs custom-input-field"
              />
            </div>
          </div>
        </div>

        <!-- 3. Grup Parameter Teknis -->
        <div class="border border-gray-200 rounded-lg p-1 bg-[#FAFAFA]">
          <div class="mb-1">
            <h5 class="text-xs font-semibold text-[#333333] mb-0">
              Parameter Teknis
            </h5>
          </div>

          <div class="space-y-1.5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-1.5">
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  fbp
                </label>
                <b-form-input
                  v-model="technicalParams.fbp"
                  type="text"
                  placeholder="fb.1.2319"
                  class="text-xs custom-input-field"
                />
              </div>
              <div>
                <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                  fbc
                </label>
                <b-form-input
                  v-model="technicalParams.fbc"
                  type="text"
                  placeholder="fb.1.24989"
                  class="text-xs custom-input-field"
                />
              </div>
            </div>

            <div>
              <label class="block text-[11px] font-medium text-[#333333] mb-0.5">
                event_id
              </label>
              <b-form-input
                type="text"
                value="Generate otomatis saat kirim"
                disabled
                class="text-xs custom-input-field bg-gray-100 text-gray-500 cursor-not-allowed"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Actions Footer -->
      <div class="flex items-center justify-end gap-1.5 mt-2 pt-1 border-t border-gray-100">
        <b-button
          variant="outline-secondary"
          size="sm"
          class="text-xs px-2.5"
          :disabled="isLoading"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="text-xs px-2.5 gap-1"
          :disabled="isLoading || !selectedEventName"
          @click="onSubmit"
        >
        <div class="flex items-center gap-1">
          <div  v-if="isLoading">
            <b-spinner
              small
            />
          </div>
          <div v-else>
            <feather-icon
              icon="SendIcon"
              size="12"
            />
          </div>
          <span>Kirim Test Event</span>
          </div>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import { META_EVENT_DESCRIPTIONS, META_EVENT_TYPE_OPTIONS } from '../config'

export default {
  name: 'ModalTestMetaCapiEvent',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    activeEvents: {
      type: Array,
      default: () => [],
    },
    defaultTestCode: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedEventType: 'standard',
      selectedEventName: '',
      eventTypeOptions: META_EVENT_TYPE_OPTIONS,
      customerData: {
        phone: '08123123123',
        external_id: '231231',
        first_name: 'Jack',
        last_name: 'Smith',
        city: 'Jakarta',
        state: 'Jakarta',
        zip: '123123',
        country: 'ID',
      },
      customData: {
        price: 350000,
        currency: 'IDR',
        product_name: 'T-Shirt Premium',
        content_type: 'product',
        quantity: 1,
      },
      technicalParams: {
        fbp: 'fb.1.2319',
        fbc: 'fb.1.24989',
      },
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    eventNameOptions() {
      return (this.activeEvents || []).map(evt => ({
        value: evt,
        label: META_EVENT_DESCRIPTIONS[evt] || evt,
      }))
    },
    // Payload Meta berbeda per event (lihat flow Figma: contact/lead/initiatecheckout/purchase)
    showCustomerLocation() {
      return ['Lead', 'InitiateCheckout', 'Purchase'].includes(this.selectedEventName)
    },
    showCustomerName() {
      return ['InitiateCheckout', 'Purchase'].includes(this.selectedEventName)
    },
    showCustomData() {
      return ['InitiateCheckout', 'Purchase'].includes(this.selectedEventName)
    },
  },
  watch: {
    activeEvents: {
      immediate: true,
      handler(events) {
        if (!Array.isArray(events) || !events.length) {
          this.selectedEventName = ''
          return
        }
        if (!events.includes(this.selectedEventName)) {
          this.selectedEventName = events[0]
        }
      },
    },
  },
  methods: {
    onCancel() {
      this.showModal = false
    },
    onSubmit() {
      if (!this.selectedEventName) return
      const payload = {
        event_key: this.selectedEventName,
        event_name: META_EVENT_DESCRIPTIONS[this.selectedEventName] || this.selectedEventName,
        event_type: this.selectedEventType,
        customer_data: { ...this.customerData },
        technical_params: { ...this.technicalParams },
        event_test_code: this.defaultTestCode,
      }
      if (this.showCustomData) payload.custom_data = { ...this.customData }
      this.$emit('submit', payload)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.custom-v-select {
  .vs__dropdown-toggle {
    border-radius: 8px !important;
    border-color: #E2E8F0 !important;
    min-height: 38px;
    background-color: #fff;
  }
  &.vs--open .vs__dropdown-toggle {
    border-color: #F97316 !important;
  }
  .vs__selected {
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  .vs__dropdown-menu {
    font-size: 12px;
    border-radius: 8px;
  }
}
</style>

<style scoped>
.custom-input-field {
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  height: 38px;
}
.custom-input-field:focus {
  border-color: #F97316 !important;
  box-shadow: 0 0 0 1px #F97316 !important;
}
</style>
